<template>
  <ul class="relative">
    <li
      v-for="item in cartItemsState.cartItems"
      :key="item.Id"
      class="w-full flex flex-col gap-16 first:pt-8 border-solid border-border-secondary relative first:md:border-t-0 pb-16"
      :class="{
        'pt-16 border-t-md':
          !item.BundlePlanItem?.IsFamilyPlan || !item.IsFamilyPlan,
        'pt-0 ': item.BundlePlanItem?.IsFamilyPlan || item.IsFamilyPlan,
      }"
    >
      <!--Only subscription or Mobile broadband-->
      <CheckoutCartItem
        v-if="
          item.Category === Category.postPaid ||
          item.Category === Category.mobileBroadBand
        "
        :img-src="
          item.ImageUrl ??
          images_selectImageUrlForSubscriptionItemInList(
            item.DataAllowance?.DataSize,
            item.RegularDataAllowance?.DataSize,
            undefined,
            item.IsFamilyPlan,
            item.Category === Category.mobileBroadBand ? true : false,
          ) ??
          undefined
        "
        product-name="Abonnemang"
        :item-info="[item.ProductName]"
        :price-string="`${item.MonthlyPrice} kr/mån`"
        :reg-price-string="
          item.RegularMonthlyPrice && item.RegularMonthlyPrice != 0
            ? item.RegularMonthlyPrice + ' kr/mån'
            : ''
        "
        :bind-period-time="item.BindingPeriod"
        :cart-item-id="item.Id"
      />

      <!--Only Pre paid-->
      <CheckoutCartItem
        v-if="item.Category === Category.prePaid"
        :img-src="
          item.ImageUrl ??
          makePrePaidImgSrc(item.DataAllowance?.DataSize, item.OneTimePrice) ??
          undefined
        "
        product-name="Kontantkort"
        :item-info="[item.ProductName]"
        :price-string="`${item.OneTimePrice} kr`"
        :reg-price-string="
          item.RegularMonthlyPrice && item.RegularMonthlyPrice != 0
            ? item.RegularMonthlyPrice + ' kr'
            : ''
        "
        :bind-period-time="item.BindingPeriod"
        :cart-item-id="item.Id"
      />

      <!--Only Accessory-->
      <CheckoutCartItem
        v-else-if="item.Category === Category.accessory"
        :img-src="item.ImageUrl ?? undefined"
        :product-name="item.ProductName"
        :item-info="[item.Color ?? ' ']"
        :price-string="
          checkoutStore.makeCartProductItemPriceStringToDisplay(item.Id)
        "
        :bind-period-time="item.BindingPeriod"
        :down-pay-time="
          checkoutStore.isKlarnaPaymentMethodSelected
            ? 1
            : item?.Payments
              ? (item?.Payments?.filter(
                  (payment) =>
                    payment.DownPayments ===
                    checkoutStore.userState.payment.selectedDownPayTime,
                ).at(0)?.DownPayments ?? 1)
              : 1
        "
        :cart-item-id="item.Id"
      />

      <!--Försäkring-->
      <CheckoutCartItem
        v-if="item.Category === Category.insurances"
        :img-src="`${config.public.publicCloudfrontDistribution}/images/logos/symbol_logo_thumb.png`"
        product-name="Mobilförsäkring"
        :item-info="[item.ProductName]"
        :price-string="`${item.PriceText}`"
        :remove-specific-item="true"
        :cart-item-id="item.Id"
        @on-remove-insurance-item="emit('onRemoveInsuranceItem', item.Id)"
      />

      <!--dumpa lur-->
      <CheckoutCartItem
        v-if="item.Category === Category.buyback"
        img-src="/images/product_related/buyback-phone.svg"
        product-name="Din inbytestelefon"
        :item-info="[
          item.ProductName,
          item.Color ?? '',
          item.Condition ?? '',
          item.StorageSize?.DataSize
            ? item.StorageSize.DataSize + (item.StorageSize.DataUnit ?? '')
            : '',
        ]"
        :item-info-secondary="makeBuybackPaymentInfoText(item)"
        :price-string="checkoutStore.makeBuybackItemPriceStringToDisplay(item)"
        :down-pay-time="
          item.PaymentReductions
            ? checkoutStore.userState.payment.selectedDownPayTime
            : (checkoutStore.fetchedData.cart.cartItems.find(
                (cartItem) => cartItem.BundlePlanItem,
              )?.BundlePlanItem?.BindingPeriod ?? 24)
        "
        :remove-specific-item="true"
        :cart-item-id="item.Id"
        provider="cloudfront"
        @click="emit('onRemoveCartItem', item.Id)"
      />

      <!-- all other hopefully phone + subscription-->
      <CheckoutCartItem
        v-else-if="item.Category === Category.phones"
        :img-src="
          item.ImageUrl ??
          images_selectImageUrlForSubscriptionItemInList(
            item.DataAllowance?.DataSize,
            item.RegularDataAllowance?.DataSize,
            undefined,
            item.IsFamilyPlan,
          ) ??
          undefined
        "
        :product-name="item?.ProductName"
        :item-info="[
          item.Color ?? '',
          item.Condition ?? '',
          item.StorageSize?.DataSize
            ? item.StorageSize.DataSize + (item.StorageSize.DataUnit ?? '')
            : '',
        ]"
        :price-string="
          checkoutStore.makeCartProductItemPriceStringToDisplay(item.Id)
        "
        :down-pay-time="
          item?.Payments
            ? (item?.Payments?.filter(
                (payment) =>
                  payment.DownPayments ===
                  checkoutStore.userState.payment.selectedDownPayTime,
              ).at(0)?.DownPayments ?? 36)
            : 36
        "
        :cart-item-id="item.Id"
      />

      <CheckoutCartItem
        v-if="item.BundlePlanItem"
        :img-src="
          images_selectImageUrlForSubscriptionItemInList(
            item.BundlePlanItem?.DataAllowance?.DataSize,
            item.BundlePlanItem?.RegularDataAllowance?.DataSize,
            undefined,
            item.BundlePlanItem?.IsFamilyPlan,
          )
        "
        product-name="Abonnemang"
        :item-info="[item.BundlePlanItem.ProductName]"
        :price-string="`${item.BundlePlanItem.MonthlyPrice} kr/mån`"
        :reg-price-string="
          item.BundlePlanItem.RegularMonthlyPrice &&
          item.BundlePlanItem.RegularMonthlyPrice != 0
            ? item.BundlePlanItem.RegularMonthlyPrice + ' kr/mån'
            : ''
        "
        :bind-period-time="item.BundlePlanItem.BindingPeriod"
        :cart-item-id="item.BundlePlanItem.Id"
      />

      <template v-if="canBeParentToChildPlans(item)">
        <CheckoutCartItem
          v-for="childPlanItem in cartItemsState.childPlanCartItems"
          :key="childPlanItem.Id"
          :img-src="
            images_selectImageUrlForSubscriptionItemInList(
              childPlanItem.DataAllowance?.DataSize,
              childPlanItem.RegularDataAllowance?.DataSize,
              undefined,
              childPlanItem.IsFamilyPlan,
            )
          "
          product-name="Abonnemang"
          :item-info="[childPlanItem.ProductName]"
          :price-string="`${childPlanItem.MonthlyPrice} kr/mån`"
          :reg-price-string="
            childPlanItem.RegularMonthlyPrice &&
            childPlanItem.RegularMonthlyPrice != 0
              ? childPlanItem.RegularMonthlyPrice + ' kr/mån'
              : ''
          "
          :bind-period-time="childPlanItem.BindingPeriod"
          :cart-item-id="childPlanItem.Id"
        />
      </template>

      <!--phone + subscription-->
      <IconButton
        :aria-label="`Ta bort ${item.ProductName} från varukorgen`"
        classes="absolute right-0"
        icon-name="x"
        @click="emit('onRemoveCartItem', item.Id)"
        @keyup.enter.self.prevent="emit('onRemoveCartItem', item.Id)"
        @keyup.space.self.prevent="emit('onRemoveCartItem', item.Id)"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { Category } from '~/models/Category.models';
import type { ShoppingCartItemModel } from '~/models/shopping_cart/ShoppingCartItem.api.model';
const checkoutStore = useMyCheckoutStore();
const emit = defineEmits(['onRemoveCartItem', 'onRemoveInsuranceItem']);
const config = useRuntimeConfig();

type CartItemsState = {
  childPlanCartItems: ShoppingCartItemModel[];
  cartItems: ShoppingCartItemModel[];
};

const canBeParentToChildPlans = (cartItem: ShoppingCartItemModel): boolean => {
  return !!(cartItem.BundlePlanItem || cartItem.Category === Category.postPaid);
};

const makePrePaidImgSrc = (
  data?: string,
  price?: number,
): string | undefined => {
  if (data && price != 0) {
    return `${config.public.publicCloudfrontDistribution}/images/prepaid/fastpris_${data}_small.png`;
  } else if (!data && price == 0) {
    return `${config.public.publicCloudfrontDistribution}/images/prepaid/startpaket_small.png`;
  } else {
    return `${config.public.publicCloudfrontDistribution}/images/prepaid/saldo_${price?.toString()}_small.png`;
  }
};

const makeBuybackPaymentInfoText = (item: ShoppingCartItemModel): string => {
  if (item.AdditionalDataAllowance && item.AdditionalDataAllowance.DataSize) {
    return 'Läggs till på ditt abonnemang när vi fått inbytes-luren.';
  }

  if (checkoutStore.userState.payment.selectedDownPayTime === 1) {
    return 'Dras av på din betalning när vi fått inbytes-luren.';
  }

  return 'Dras av på din delbetalning när vi fått inbytes-luren.';
};

const cartItemsState: ComputedRef<CartItemsState> = computed(() => {
  const allCartItems = checkoutStore.fetchedData.cart.cartItems;
  const nonChildPlanCartItems = allCartItems.filter(
    (item) => item.IsFamilyPlan === false,
  );
  let childPlanCartItems = allCartItems.filter(
    (item) => item.IsFamilyPlan === true,
  );

  const existingCustomerChildPlansWouldNotRender =
    childPlanCartItems.length > 0 &&
    nonChildPlanCartItems.find((cartItem) =>
      canBeParentToChildPlans(cartItem),
    ) === undefined;

  if (
    existingCustomerChildPlansWouldNotRender &&
    childPlanCartItems.length > 0
  ) {
    nonChildPlanCartItems.unshift(childPlanCartItems[0]);
    childPlanCartItems = childPlanCartItems.slice(1);
  }

  return {
    childPlanCartItems: childPlanCartItems,
    cartItems: nonChildPlanCartItems,
  };
});
</script>
